import styled from "styled-components"



export const Entry = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;

  &:last-of-type {
    > div {
      border-bottom: none;
    }
  }
`

export const Message = styled.div`
  text-transform: capitalize;
  font-weight: 700;
  display: flex;
  align-items: center;
  svg {
    width: 1.5rem;
    margin-left: 1rem;
    fill: ${(p) => p.theme.colors.greyDark};
    &:hover {
      cursor: pointer;
    }
  }
`

export const Info = styled.div`
  margin-top: 1rem;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
`

export const EntryDate = styled.div`
  background: ${(p) => p.theme.colors.turquoiseLighter};
  border: 0.1rem solid ${(p) => p.theme.colors.turquoiseBorder};
  border-radius: 0.5rem;
  padding: 0.3rem 1rem;
  font-size: 1.1rem;
  width: 13rem;
  margin-left: 1rem;
`

export const IconWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 3.4rem;
  flex-shrink: 0;
`

export const Icon = styled.div`
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 1.7rem;
  background: ${(p) => p.theme.colors.greyLight};
  border: 0.3rem solid ${(p) => p.theme.colors.white};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffe6e6;
  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: #e64d4d;
  }
`

export const EntryEvent = styled.div`
  align-items: center;
  line-height: 1.8rem;
  display: flex;
  gap: 1rem;
  padding: 1.5rem 0;
  width: 100%;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLighter};
  justify-content: space-between;
`
